import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c43416a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "uq-preloader"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader loader--3" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "patient-file-container pt-16"
}
const _hoisted_5 = { class: "mb-12" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-expand-right me-12",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_7 = { class: "patient-resume mb-32" }
const _hoisted_8 = { class: "p-24" }
const _hoisted_9 = { class: "patient-header d-flex flex-column flex-xl-row justify-content-between mb-32" }
const _hoisted_10 = { class: "h4 text-primary mb-12 mb-xl-0 me-xl-16" }
const _hoisted_11 = { class: "fw-normal" }
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = { class: "patient-data" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-6 col-lg-4 col-xl-3 mb-16" }
const _hoisted_16 = { class: "fw-bold" }
const _hoisted_17 = {
  key: 0,
  class: "fw-normal"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "fw-normal"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close me-8",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_21 = { class: "fw-normal" }
const _hoisted_22 = { class: "col-6 col-lg-3 col-xl-3 mb-16" }
const _hoisted_23 = { class: "fw-bold mb-0" }
const _hoisted_24 = {
  key: 0,
  class: "fw-normal"
}
const _hoisted_25 = ["href", "aria-label", "title"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-view-light fw-bold me-8",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 1,
  class: "fw-normal"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-edit-light me-8",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_30 = { class: "fw-normal" }
const _hoisted_31 = { class: "col col-lg-2 col-xl-2 mb-16" }
const _hoisted_32 = { class: "fw-bold mb-0" }
const _hoisted_33 = { class: "fw-normal" }
const _hoisted_34 = { class: "col col-lg-3 col-xl-2 mb-16" }
const _hoisted_35 = { class: "fw-bold mb-0" }
const _hoisted_36 = { class: "fw-normal" }
const _hoisted_37 = { class: "col col-lg-4 col-xl-2 mb-16" }
const _hoisted_38 = { class: "d-flex align-items-center" }
const _hoisted_39 = { class: "fw-bold me-4" }
const _hoisted_40 = {
  key: 0,
  class: "fw-normal"
}
const _hoisted_41 = {
  key: 1,
  class: "fw-normal"
}
const _hoisted_42 = { class: "patient-tabs" }
const _hoisted_43 = { class: "nav nav-tabs nav-justified" }
const _hoisted_44 = { class: "nav-item" }
const _hoisted_45 = ["aria-label"]
const _hoisted_46 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_47 = ["aria-label"]
const _hoisted_48 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_49 = ["aria-label"]
const _hoisted_50 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_51 = ["aria-label"]
const _hoisted_52 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_53 = ["aria-label"]
const _hoisted_54 = {
  key: 4,
  class: "nav-item"
}
const _hoisted_55 = ["aria-label"]
const _hoisted_56 = {
  class: "tab-content py-3",
  id: "myTabContent"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_protocol_name = _resolveComponent("v-protocol-name")!
  const _component_the_professional_expedient_file_general = _resolveComponent("the-professional-expedient-file-general")!
  const _component_the_professional_expedient_file_medical_data = _resolveComponent("the-professional-expedient-file-medical-data")!
  const _component_the_professional_consultation = _resolveComponent("the-professional-consultation")!
  const _component_the_professional_expedient_anamnesis_tab = _resolveComponent("the-professional-expedient-anamnesis-tab")!
  const _component_the_purchase_authorization_list = _resolveComponent("the-purchase-authorization-list")!
  const _component_the_professional_document = _resolveComponent("the-professional-document")!
  const _component_the_professional_patient_personal_data_modal = _resolveComponent("the-professional-patient-personal-data-modal")!
  const _component_the_professional_treatment_finish_confirm_modal = _resolveComponent("the-professional-treatment-finish-confirm-modal")!
  const _component_the_professional_treatment_change_phase_modal = _resolveComponent("the-professional-treatment-change-phase-modal")!
  const _component_the_professional_anamnesis = _resolveComponent("the-professional-anamnesis")!
  const _component_the_anamnesis_results_modal = _resolveComponent("the-anamnesis-results-modal")!
  const _component_the_video_call_overlay = _resolveComponent("the-video-call-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.status === 'loading')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.currentExpedient && _ctx.currentExpedient.patient
  && _ctx.status === 'loaded')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              class: "btn btn-link-primary btn-sm ps-0",
              to: {name: 'professional.expedient.index'},
              "aria-label": _ctx.$t('Volver')
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('Volver')), 1)
              ]),
              _: 1
            }, 8, ["to", "aria-label"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h2", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.$t('Ficha del paciente:')) + " ", 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.currentExpedient.patient.user.name) + " " + _toDisplayString(_ctx.currentExpedient.patient.user.surname), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  (!_ctx.currentTreatment && _ctx.can('professional.expedient.anamnesis.start'))
                    ? (_openBlock(), _createBlock(_component_v_button, {
                        key: 0,
                        variant: "secondary",
                        class: "me-16",
                        "aria-label": _ctx.$t('Iniciar tratamiento'),
                        onClick: _ctx.startAnamnesis
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Iniciar tratamiento')), 1)
                        ]),
                        _: 1
                      }, 8, ["aria-label", "onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.can('professional.patient.show'))
                    ? (_openBlock(), _createBlock(_component_v_button, {
                        key: 1,
                        variant: "link-secondary",
                        "aria-label": _ctx.$t('Datos personales'),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalToShow = 'the-professional-patient-personal-data-modal'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Datos personales')), 1)
                        ]),
                        _: 1
                      }, 8, ["aria-label"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Protocolo:')) + " ", 1),
                      (_ctx.currentTreatment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_v_protocol_name, {
                              text: _ctx.protocolName(),
                              color: _ctx.protocolType()
                            }, null, 8, ["text", "color"]),
                            (_ctx.currentTreatment.status === 'finalized')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('(Finalizado)')), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('- Sin datos -')), 1))
                    ]),
                    (_ctx.currentTreatment && _ctx.can('professional.expedient.treatment.finish') &&
                _ctx.currentTreatment.status !== 'finalized')
                      ? (_openBlock(), _createBlock(_component_v_button, {
                          key: 0,
                          variant: "secondary",
                          class: "btn-icon p-8 me-8 mt-8",
                          "aria-label": _ctx.$t('Finalizar tratamiento'),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalToShow = 'the-professional-treatment-finish-confirm-modal'))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_20,
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('Finalizar tratamiento')), 1)
                          ]),
                          _: 1
                        }, 8, ["aria-label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("p", _hoisted_23, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Fase:')) + " ", 1),
                      (_ctx.currentTreatment)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                            _createTextVNode(_toDisplayString(_ctx.phaseActive().protocolPhase.name) + " ", 1),
                            _createElementVNode("a", {
                              target: "_blank",
                              href: _ctx.getProtocolPhaseUrl(),
                              "aria-label": _ctx.$t('Ver'),
                              title: _ctx.$t('Ver')
                            }, _hoisted_27, 8, _hoisted_25),
                            _createElementVNode("span", {
                              class: "icon icon-import fw-bold me-8 clickable",
                              "aria-hidden": "true",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.downloadProtocolPhase && _ctx.downloadProtocolPhase(...args)))
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('- Sin datos -')), 1))
                    ]),
                    (_ctx.currentTreatment && _ctx.can('professional.expedient.treatment.change-phase') &&
                _ctx.currentTreatment.status === 'active' && _ctx.protocolPhases.length > 1)
                      ? (_openBlock(), _createBlock(_component_v_button, {
                          key: 0,
                          variant: "secondary",
                          class: "btn-icon p-8 me-8 mt-8",
                          "aria-label": _ctx.$t('Cambiar de fase'),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalToShow = 'the-professional-treatment-change-phase-modal'))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_29,
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('Cambiar de fase')), 1)
                          ]),
                          _: 1
                        }, 8, ["aria-label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("p", _hoisted_32, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Fecha de inicio:')) + " ", 1),
                      _createElementVNode("span", _hoisted_33, _toDisplayString(!_ctx.currentTreatment ? _ctx.$t('- Sin datos -') : _ctx.$str.formatDate(_ctx.phaseActive().initDate)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("p", _hoisted_35, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Última consulta:')) + " ", 1),
                      _createElementVNode("span", _hoisted_36, _toDisplayString(!_ctx.lastConsultation ? _ctx.$t('- Sin datos -') : _ctx.$str.formatDate(_ctx.lastConsultation.initDate)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('GRPD:')), 1),
                      (!!_ctx.currentExpedient.rgpdConfirmedAt)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.$t('Válido')), 1))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_ctx.can('professional.patient.rgpd'))
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  class: "btn btn-link-secondary btn-sm p-0",
                                  to: {name: 'professional.patient.rgpd',
                     params: { expedient:  _ctx.currentExpedient.id} },
                                  "aria-label": _ctx.$t('Reenviar')
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('Reenviar')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["to", "aria-label"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.$t('Sin aceptar')), 1))
                          ], 64))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("ul", _hoisted_43, [
              _createElementVNode("li", _hoisted_44, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", {'router-link-active router-link-exact-active': _ctx.isActive('general')}]),
                  "aria-label": _ctx.$t('General'),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeExpedientSection('general')))
                }, _toDisplayString(_ctx.$t('General')), 11, _hoisted_45)
              ]),
              (_ctx.can('professional.expedient.form.index'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_46, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["nav-link", {'router-link-active router-link-exact-active': _ctx.isActive('datos-medicos')}]),
                      "aria-label": _ctx.$t('Datos médicos'),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeExpedientSection('datos-medicos')))
                    }, _toDisplayString(_ctx.$t('Datos médicos')), 11, _hoisted_47)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.can('professional.expedient.consultation.index'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_48, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["nav-link", {'router-link-active router-link-exact-active': _ctx.isActive('consultas')}]),
                      "aria-label": _ctx.$t('Consultas'),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeExpedientSection('consultas')))
                    }, _toDisplayString(_ctx.$t('Consultas')), 11, _hoisted_49)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.can('professional.expedient.anamnesis.start'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_50, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["nav-link", {'router-link-active router-link-exact-active': _ctx.isActive('anamnesis')}]),
                      "aria-label": _ctx.$t('Anamnesis'),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeExpedientSection('anamnesis')))
                    }, _toDisplayString(_ctx.$t('Anamnesis')), 11, _hoisted_51)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.can('professional.expedient.purchase-authorization.index'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_52, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["nav-link", {'router-link-active router-link-exact-active': _ctx.isActive('autorizacion-compra')}]),
                      "aria-label": _ctx.$t('Autorización de compra'),
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeExpedientSection('autorizacion-compra')))
                    }, _toDisplayString(_ctx.$t('Autorización de compra')), 11, _hoisted_53)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.can('professional.expedient.file.download'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_54, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["nav-link", { 'router-link-active router-link-exact-active': _ctx.isActive('documentos')}]),
                      "aria-label": _ctx.$t('Documentos'),
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeExpedientSection('documentos')))
                    }, _toDisplayString(_ctx.$t('Documentos')), 11, _hoisted_55)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", {
                id: "general",
                class: _normalizeClass(["tab-pane fade py-32", {'active show': _ctx.isActive('general') }])
              }, [
                (_ctx.isActive('general'))
                  ? (_openBlock(), _createBlock(_component_the_professional_expedient_file_general, {
                      key: 0,
                      onShowStartAnamnesisModal: _ctx.startAnamnesis
                    }, null, 8, ["onShowStartAnamnesisModal"]))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                id: "medicalData",
                class: _normalizeClass(["tab-pane fade py-32", {'active show': _ctx.isActive('datos-medicos') }])
              }, [
                (_ctx.isActive('datos-medicos'))
                  ? (_openBlock(), _createBlock(_component_the_professional_expedient_file_medical_data, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                id: "consultations",
                class: _normalizeClass(["tab-pane fade py-32", {'active show': _ctx.isActive('consultas') }])
              }, [
                (_ctx.isActive('consultas'))
                  ? (_openBlock(), _createBlock(_component_the_professional_consultation, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                id: "anamnesis",
                class: _normalizeClass(["tab-pane fade py-32", { 'active show': _ctx.isActive('anamnesis') }])
              }, [
                (_ctx.isActive('anamnesis'))
                  ? (_openBlock(), _createBlock(_component_the_professional_expedient_anamnesis_tab, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                id: "purchaseAuthorization",
                class: _normalizeClass(["tab-pane fade py-32", {'active show': _ctx.isActive('autorizacion-compra') }])
              }, [
                (_ctx.isActive('autorizacion-compra'))
                  ? (_openBlock(), _createBlock(_component_the_purchase_authorization_list, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                id: "documents",
                class: _normalizeClass(["tab-pane fade py-32", { 'active show': _ctx.isActive('documentos') }])
              }, [
                (_ctx.isActive('documentos'))
                  ? (_openBlock(), _createBlock(_component_the_professional_document, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.modalToShow === 'the-professional-patient-personal-data-modal')
      ? (_openBlock(), _createBlock(_component_the_professional_patient_personal_data_modal, {
          key: 2,
          patient: _ctx.currentExpedient.patient,
          onClosed: _cache[10] || (_cache[10] = ($event: any) => (_ctx.modalToShow = null))
        }, null, 8, ["patient"]))
      : _createCommentVNode("", true),
    (_ctx.modalToShow === 'the-professional-treatment-finish-confirm-modal')
      ? (_openBlock(), _createBlock(_component_the_professional_treatment_finish_confirm_modal, {
          key: 3,
          onTreatmentFinished: _ctx.handleTreatmentFinishedEvent,
          onClosed: _cache[11] || (_cache[11] = ($event: any) => (_ctx.modalToShow = null))
        }, null, 8, ["onTreatmentFinished"]))
      : _createCommentVNode("", true),
    (_ctx.modalToShow === 'the-professional-treatment-change-phase-modal')
      ? (_openBlock(), _createBlock(_component_the_professional_treatment_change_phase_modal, {
          key: 4,
          "phase-id": _ctx.phaseActive().protocolPhase.id,
          onTreatmentPhaseChanged: _ctx.handleTreatmentPhaseChangedEvent,
          onClosed: _cache[12] || (_cache[12] = ($event: any) => (_ctx.modalToShow = null))
        }, null, 8, ["phase-id", "onTreatmentPhaseChanged"]))
      : _createCommentVNode("", true),
    (_ctx.modalToShow === 'the-professional-anamnesis')
      ? (_openBlock(), _createBlock(_component_the_professional_anamnesis, {
          key: 5,
          onClosed: _cache[13] || (_cache[13] = ($event: any) => (_ctx.modalToShow = null)),
          onSuggestProtocolsFromAnamnesisRequested: _ctx.openTheAnamnesisResultsModal,
          onAlertsUpdated: _ctx.handleAlertsUpdatedEvent
        }, null, 8, ["onSuggestProtocolsFromAnamnesisRequested", "onAlertsUpdated"]))
      : _createCommentVNode("", true),
    (_ctx.modalToShow === 'the-anamnesis-results-modal')
      ? (_openBlock(), _createBlock(_component_the_anamnesis_results_modal, {
          key: 6,
          alerts: _ctx.anamnesisAlerts,
          onClosed: _cache[14] || (_cache[14] = ($event: any) => (_ctx.modalToShow = null))
        }, null, 8, ["alerts"]))
      : _createCommentVNode("", true),
    (_ctx.currentExpedient && _ctx.currentExpedient.patient
  && _ctx.status === 'loaded')
      ? (_openBlock(), _createBlock(_component_the_video_call_overlay, { key: 7 }))
      : _createCommentVNode("", true)
  ], 64))
}